import React from 'react';
import {graphql} from 'gatsby';
import Dnsmpi from '../components/Dnsmpi/Dnsmpi';

const IndexPage = ({data}) => {
    const {
        content: {dnsmpi},
    } = JSON.parse(data.sheets.jsonPayload);

    return <Dnsmpi {...dnsmpi} domain=".vrbo.com" />;
};

export default IndexPage;

export const ContentQuery = graphql`
    query {
        sheets {
            jsonPayload
        }
    }
`;
